import { ServiceTypes } from 'utils/constants/venues';

const getServiceTypeLabel = serviceType => {
  switch (serviceType) {
    case ServiceTypes.TABLE_AND_COLLECTION:
      return 'Table Service + Collection';
    case ServiceTypes.TABLE_ONLY:
      return 'Table Service Only';
    case ServiceTypes.COLLECTION_ONLY:
      return 'Collection Only';
    default:
      return 'Unknown';
  }
};

export default getServiceTypeLabel;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Panels/MultiVenue/components/GroupDetails/utils/getServiceTypeLabel.js